import type { RequestConfig } from '@customTypes/index';
import type { CategorisedResponse } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type GetCategorisedActivityesListParams = RequestConfig;

export const getCategorisedActivityesList = async ({
  config
}: GetCategorisedActivityesListParams) =>
  api.get<CategorisedResponse>(`/api/UserActivities/support/kanban`, config);
